import '../games/sephocrush/sephocrush.css';
import { launchConfetti } from './confetti';

const sephocrushScriptUrl = '/build/games/sephocrush/sephocrush.min.js';

import imgBackground from '../games/sephocrush/images/background.svg';
import imgLogo from '../games/sephocrush/images/logo.svg';
import imgDiamond from '../games/sephocrush/images/diamond.svg';
import imgResultWow from '../games/sephocrush/images/result-wow.svg';
import imgAudioOn from '../games/sephocrush/images/audio-on.svg';
import imgAudioOff from '../games/sephocrush/images/audio-off.svg';
import imgMusicOn from '../games/sephocrush/images/music-on.svg';
import imgMusicOff from '../games/sephocrush/images/music-off.svg';
import imgHeartFull from '../games/sephocrush/images/heart-full.svg';
import imgHeartEmpty from '../games/sephocrush/images/heart-empty.svg';
import imgHeader from '../games/sephocrush/images/header.svg';
import imgPause from '../games/sephocrush/images/pause.svg';
import imgSephoDashes from '../games/sephocrush/images/sepho-dashes.svg';
import imgComboX2 from '../games/sephocrush/images/combo-x2.svg';
import imgComboX3 from '../games/sephocrush/images/combo-x3.svg';
import imgComboX4 from '../games/sephocrush/images/combo-x4.svg';
import imgComboX5 from '../games/sephocrush/images/combo-x5.svg';
import imgGem1 from '../games/sephocrush/images/gem1-1.svg';
import imgGem2 from '../games/sephocrush/images/gem2-1.svg';
import imgGem3 from '../games/sephocrush/images/gem3-1.svg';
import imgGem4 from '../games/sephocrush/images/gem4-1.svg';
import imgGem5 from '../games/sephocrush/images/gem5-1.svg';
import imgGem6 from '../games/sephocrush/images/gem6-1.svg';
import imgGemSpecial from '../games/sephocrush/images/gem-special.svg';

import sndMatch from '../games/sephocrush/sounds/ka-ching2.webm';
import sndInvalid from '../games/sephocrush/sounds/chomp.webm';
import sndGameOver from '../games/sephocrush/sounds/completed.webm';
import sndCountdown from '../games/sephocrush/sounds/wrong.wav';
import sndClick from '../games/sephocrush/sounds/click.webm';
import sndMusic from '../games/sephocrush/sounds/musiccandy.webm';
import sndStarMatch from '../games/sephocrush/sounds/target.webm';
import sndComboX2 from '../games/sephocrush/sounds/combo1.webm';
import sndComboX3 from '../games/sephocrush/sounds/combo2.webm';
import sndComboX4 from '../games/sephocrush/sounds/combo3.webm';
import sndComboX5 from '../games/sephocrush/sounds/combo4.webm';

(function () {
    const modal = document.querySelector('#js-sephocrush-modal');
    if (!modal) return;

    // ── Session state ──────────────────────────────────────────────────────────

    let gameInstance  = null;
    let sessionToken  = null;

    function resetSessionState() {
        sessionToken = null;
    }

    function sendJson(path, body) {
        return fetch('/api/games/sephocrush/' + path, {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify(body),
        }).then(r => r.json());
    }

    // ── Open / close ───────────────────────────────────────────────────────────

    // Gem images are drawn onto the board the instant the game starts. Preload
    // them so the board never renders with invisible/blank gems.
    const gemImageUrls = [imgGem1, imgGem2, imgGem3, imgGem4, imgGem5, imgGem6, imgGemSpecial];

    function preloadImages(urls) {
        return Promise.all(urls.map(url => new Promise((resolve) => {
            const img = new Image();
            img.onload = resolve;
            img.onerror = resolve; // don't block the game if one asset fails
            img.src = url;
        })));
    }

    function loadScript(src) {
        return new Promise((resolve, reject) => {
            if (document.querySelector('script[src="' + src + '"]')) {
                resolve();
                return;
            }
            const s = document.createElement('script');
            s.src = src;
            s.onload = resolve;
            s.onerror = reject;
            document.head.appendChild(s);
        });
    }

    function openGame() {
        Promise.all([loadScript(sephocrushScriptUrl), preloadImages(gemImageUrls)])
            .then(initGame)
            .catch(() => console.error('SephoCrush: failed to load game script'));

        modal.classList.add('is-open');
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('has-game-open');
    }

    function closeGame() {
        modal.classList.remove('is-open');
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('has-game-open');
    }

    // ── Game initialisation ────────────────────────────────────────────────────

    function initGame() {
        if (typeof SephoCrushGame === 'undefined') {
            console.error('SephoCrush: SephoCrushGame not defined after script load');
            return;
        }

        if (gameInstance) {
            try { gameInstance.destroy(); } catch { /* ignore */ }
            gameInstance = null;
        }
        resetSessionState();

        gameInstance = SephoCrushGame.init('js-sephocrush-game', {
            assetsConfig: {
                texts: {
                    gameTitle: 'SephoCrush',
                    gameSubtitle: 'Łącz klejnoty w rzędy po 3 lub więcej!',
                    startButton: 'Graj',
                    livesLabel: 'Życia',
                    loading: 'Ładowanie...',
                    timeoutToast: 'Czas minął!',
                    comboToast: 'Combo x{combo}!',
                    resultTitle: 'KONIEC GRY',
                    resultScore: 'TWÓJ WYNIK:',
                    resultText1: 'GRATULACJE',
                    resultText2: 'ŚWIETNA ROZGRYWKA!',
                    resultLives: 'Pozostałe życia',
                    resultButton: 'MENU',
                    errorNoLives: 'Nie masz żyć. Wróć później!',
                    pauseHeader: 'PAUZA',
                    pauseMenu: 'Zakończ grę',
                    pauseResume: 'Wznów',
                },
                images: {
                    background: imgBackground,
                    logo: imgLogo,
                    diamondIcon: imgDiamond,
                    resultImage: imgResultWow,
                    audioOn: imgAudioOn,
                    audioOff: imgAudioOff,
                    musicOn: imgMusicOn,
                    musicOff: imgMusicOff,
                    lifeIndicator: imgHeartFull,
                    lostLifeIndicator: imgHeartEmpty,
                    boardHeader: imgHeader,
                    pause: imgPause,
                    pauseModal: imgSephoDashes,
                    comboX2: imgComboX2,
                    comboX3: imgComboX3,
                    comboX4: imgComboX4,
                    comboX5: imgComboX5,
                    gems: [
                        imgGem1,
                        imgGem2,
                        imgGem3,
                        imgGem4,
                        imgGem5,
                        imgGem6,
                    ],
                    specialGem: imgGemSpecial,
                },
                sounds: {
                    match: sndMatch,
                    invalid: sndInvalid,
                    gameOver: sndGameOver,
                    countdown: sndCountdown,
                    click: sndClick,
                    music: sndMusic,
                    starMatch: sndStarMatch,
                    comboX2: sndComboX2,
                    comboX3: sndComboX3,
                    comboX4: sndComboX4,
                    comboX5: sndComboX5,
                },
                colors: {
                    primary: '#ff9118',
                    success: '#4cff91',
                    danger: '#ff4f4f',
                    black: '#1a0a2e',
                    surface: '#fbc255',
                    text: '#fffff0',
                    textMuted: '#4d4d4d',
                    timerBar: '#e2005b',
                    timerBarDanger: '#ff4f4f',
                    gradient: 'linear-gradient(315deg, #FFAF45 9.47%, #FF4E31 49.5%, #FF66CC 89.54%)',
                    gem0: '#e2005b',
                    gem1: '#ffd700',
                    gem2: '#00e096',
                    gem3: '#3d9bff',
                    gem4: '#b06be4',
                    gem5: '#ff8c42',
                    gemSpecial: '#ffffff',
                },
            },
            gameConfig: {
                gridRows: 8,
                gridCols: 8,
                gemTypes: 6,

                specialGemChance: 0.03,
                specialGemInitLimit: 3,

                timeLimitSeconds: 60,
                timerWarnSeconds: 10,

                pointsPerGem: 10,
                matchSizeBonus: 15,
                comboMultipliers: [1, 1.5, 2, 3, 5, 8],
                timeBonusBase: 2,

                scoreSegments: [200, 500, 900, 1400],

                skipResultScreen: true,
            },
            apiConfig: {
                useMock: false,
                endpoints: {
                    startGame:    '/api/games/sephocrush/start',
                    submitResult: '/api/games/sephocrush/result',
                    heartbeat:    '/api/games/sephocrush/heartbeat',
                },
            },
            callbacks: {
                onGameEnd: (gameData) => {
                    pendingChallengeData = null;

                    const unlockedChallenges = gameData?.unlockedChallenges ?? [];
                    if (unlockedChallenges.length > 0) {
                        const uc  = unlockedChallenges[0];
                        const btn = Array.from(document.querySelectorAll('.sc-challenge-btn'))
                            .find(b => b.dataset.title === uc.title);
                        pendingChallengeData = {
                            title:            uc.title,
                            rankingPoints:    uc.rankingPoints,
                            redeemablePoints: uc.redeemablePoints,
                            image:            btn ? (btn.dataset.image       || '') : '',
                            description:      btn ? (btn.dataset.description || '') : '',
                        };
                    }

                    const rankingPoints    = gameData?.rankingPointsEarned    ?? 0;
                    const redeemablePoints = gameData?.redeemablePointsEarned ?? 0;
                    resetSessionState();
                    closeGame();
                    populateResult(rankingPoints, redeemablePoints);
                    showScreen('result');
                },
                onError: (error) => {
                    resetSessionState();
                    closeGame();
                    const errorCode = error?.data?.error;
                    if (errorCode === 'no_lives') {
                        showError('Nie masz żyć. Wróć później! 💔');
                    } else if (errorCode === 'game_in_progress') {
                        showError('Wygląda na to, że masz inną grę w toku. Poczekaj kilka minut i spróbuj ponownie');
                    } else {
                        showError('Wystąpił błąd. Spróbuj ponownie.');
                    }
                    showScreen('main');
                },
                onLauncherClose: () => {
                    resetSessionState();
                    closeGame();
                    showScreen('main');
                },
            },
        });

        // ── EventBus listeners ─────────────────────────────────────────────────

        if (gameInstance?.eventBus) {
            gameInstance.eventBus.on('game:start', (data) => {
                // Engine returns sessionToken in the start response; grab it.
                sessionToken = gameInstance.sessionToken ?? data?.sessionToken ?? null;
            });

            gameInstance.eventBus.on('segment:reached', (data) => {
                if (!sessionToken) return;
                sendJson('segment', {
                    sessionToken,
                    segment: data?.segment ?? 0,
                    score:   data?.score   ?? 0,
                }).catch(() => {});
            });

            gameInstance.eventBus.on('game:pause', (data) => {
                if (!sessionToken) return;
                sendJson('pause', { sessionToken, segment: data?.segment ?? 0 }).catch(() => {});
            });

            gameInstance.eventBus.on('game:resume', async () => {
                if (!sessionToken) return;
                const token = sessionToken; // capture before potential reset

                let response;
                try {
                    response = await sendJson('resume', { sessionToken: token });
                } catch {
                    return; // network error — let the game continue
                }

                if (response?.alive === false) {
                    // Session was abandoned while paused. Show the earned points and close.
                    const rankingPoints    = response.rankingPointsEarned    ?? 0;
                    const redeemablePoints = response.redeemablePointsEarned ?? 0;

                    resetSessionState();
                    if (gameInstance) {
                        try { gameInstance.destroy(); } catch { /* ignore */ }
                        gameInstance = null;
                    }
                    closeGame();
                    showError('Sesja gry wygasła — wynik został zapisany!');
                    populateResult(rankingPoints, redeemablePoints);
                    showScreen('result');
                }
                // alive === true: game resumes normally, no action needed.
            });
        }

    }

    // ── Error toast ───────────────────────────────────────────────────────────

    function showError(message) {
        let toast = document.querySelector('#js-sc-error-toast');
        if (!toast) {
            toast = document.createElement('div');
            toast.id = 'js-sc-error-toast';
            toast.className = 'sc-error-toast';
            document.body.appendChild(toast);
        }
        toast.textContent = message;
        toast.classList.add('is-visible');
        clearTimeout(toast._hideTimer);
        toast._hideTimer = setTimeout(() => toast.classList.remove('is-visible'), 4000);
    }

    // ── Screen switching ───────────────────────────────────────────────────────

    let pendingChallengeData = null;

    const screens = {
        main:       document.querySelector('#js-sc-main'),
        challenges: document.querySelector('#js-sc-challenges'),
        detail:     document.querySelector('#js-sc-detail'),
        result:     document.querySelector('#js-sc-result'),
        completed:  document.querySelector('#js-sc-completed'),
        howToPlay:  document.querySelector('#js-sc-how-to-play'),
        points:     document.querySelector('#js-sc-points'),
    };

    function showScreen(name) {
        Object.entries(screens).forEach(([k, el]) => {
            if (el) el.hidden = k !== name;
        });
        window.scrollTo(0, 0);
    }

    // ── Detail population ─────────────────────────────────────────────────────

    function isProgressable(dataset) {
        if(dataset.status === 'completed' || dataset.status === 'missed') return false;
        const ct = dataset.conditionType;
        const cv = parseInt(dataset.conditionValue || '0', 10);
        return (ct === 'games_played_today' && cv > 1)
            || (ct === 'games_with_min_points' && cv > 1)
            || ct === 'points_earned_today'
            || ct === 'points_earned_week';
    }

    function populateDetail(dataset) {
        const icon          = document.querySelector('#js-sc-detail-icon');
        const title         = document.querySelector('#js-sc-detail-title');
        const desc          = document.querySelector('#js-sc-detail-desc');
        const redeemEl      = document.querySelector('#js-sc-detail-redeemable');
        const rankEl        = document.querySelector('#js-sc-detail-ranking');
        const progressWrap  = document.querySelector('#js-sc-detail-progress');
        const progressFill  = document.querySelector('#js-sc-detail-progress-fill');
        const progressText  = document.querySelector('#js-sc-detail-progress-text');
        const joinBtn       = document.querySelector('#js-sc-detail-join');
        const rewardsLabel  = document.querySelector('#js-sc-detail-rewards-label');
        const rewardsEl     = document.querySelector('#js-sc-detail-rewards-label')?.closest('.sc-detail__rewards');

        const completed = dataset.status === 'completed';
        const missed    = dataset.status === 'missed';

        if (icon) {
            icon.innerHTML = dataset.image
                ? '<img class="sc-detail__img" src="' + dataset.image + '" alt="">'
                : '<div class="sc-detail__img-placeholder"></div>';
        }
        if (title)         title.textContent         = dataset.title    || '';
        if (desc)          desc.textContent           = dataset.description || '';
        if (redeemEl)      redeemEl.textContent       = `+${dataset.redeemablePoints}` || '0';
        if (rankEl)        rankEl.textContent         = `+${dataset.rankingPoints}`    || '0';
        if (joinBtn)       joinBtn.hidden             = completed || missed;
        if (rewardsLabel)  rewardsLabel.textContent   = completed ? 'zdobyte' : (missed ? 'było można zgarnąć' : 'zgarnij');
        if (rewardsEl)     rewardsEl.classList.toggle('sc-detail__rewards--missed',    missed);
        if (rewardsEl)     rewardsEl.classList.toggle('sc-detail__rewards--completed', completed);

        if (progressWrap) {
            const showProgress = isProgressable(dataset);
            progressWrap.hidden = !showProgress;
            if (showProgress) {
                const current = parseInt(dataset.currentProgress || '0', 10);
                const max     = parseInt(dataset.conditionValue  || '0', 10);
                const pct     = max > 0 ? Math.min(100, Math.round(current / max * 100)) : 0;
                if (progressFill) progressFill.style.width = pct + '%';
                if (progressText) progressText.textContent = current + ' / ' + max;
            }
        }
    }

    function populateResult(rankingPoints, redeemablePoints) {
        const redeemEl = document.querySelector('#js-sc-result-redeemable');
        const rankEl   = document.querySelector('#js-sc-result-ranking');
        if (redeemEl) redeemEl.textContent = `+${redeemablePoints}`;
        if (rankEl)   rankEl.textContent   = `+${rankingPoints}`;
    }

    function populateCompleted(data) {
        const icon      = document.querySelector('#js-sc-completed-icon');
        const title     = document.querySelector('#js-sc-completed-title');
        const desc      = document.querySelector('#js-sc-completed-desc');
        const redeemEl  = document.querySelector('#js-sc-completed-redeemable');
        const rankEl    = document.querySelector('#js-sc-completed-ranking');

        if (icon) {
            icon.innerHTML = data.image
                ? '<img class="sc-detail__img" src="' + data.image + '" alt="">'
                : '<div class="sc-detail__img-placeholder"></div>';
        }
        if (title)    title.textContent    = data.title    || '';
        if (desc)     desc.textContent     = data.description || '';
        if (redeemEl) redeemEl.textContent = `+${data.redeemablePoints}` || '0';
        if (rankEl)   rankEl.textContent   = `+${data.rankingPoints}`    || '0';
    }

    // ── Challenge buttons ─────────────────────────────────────────────────────

    document.querySelectorAll('.sc-challenge-btn').forEach((btn) => {
        // Old, uncompleted (missed) challenges are not clickable.
        if (btn.dataset.status === 'missed') return;

        btn.addEventListener('click', (e) => {
            e.preventDefault();
            populateDetail(btn.dataset);
            showScreen('detail');
        });
    });

    document.querySelector('#js-sc-detail-back')
        ?.addEventListener('click', () => showScreen('challenges'));

    document.querySelector('#js-sc-result-close')
        ?.addEventListener('click', () => {
            if (pendingChallengeData) {
                populateCompleted(pendingChallengeData);
                pendingChallengeData = null;
                showScreen('completed');
                launchConfetti();
            } else {
                window.location.reload();
            }
        });

    document.querySelector('#js-sc-completed-back')
        ?.addEventListener('click', () => window.location.reload());

    // ── Main ↔ challenges nav ─────────────────────────────────────────────────

    document.querySelector('#js-sc-btn-challenges')
        ?.addEventListener('click', (e) => { e.preventDefault(); showScreen('challenges'); });

    document.querySelector('#js-sc-back')
        ?.addEventListener('click', () => showScreen('main'));

    document.querySelector('#js-sc-btn-how-to-play')
        ?.addEventListener('click', (e) => { e.preventDefault(); showScreen('howToPlay'); });

    document.querySelector('#js-sc-btn-points')
        ?.addEventListener('click', (e) => { e.preventDefault(); showScreen('points'); });

    document.querySelectorAll('.js-sc-info-back')
        .forEach((btn) => btn.addEventListener('click', () => showScreen('main')));

    // ── Boot ───────────────────────────────────────────────────────────────────

    document.querySelectorAll('.js-sc-start-game').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            openGame();
        });
    });
}());
